<template>
  <div
    :class="isEnd ? 'p-3 mb-n3' : 'mx-auto my-3 rounded overflow-hidden'"
    :style="{ 'max-width': isEnd ? '' : '640px'}"
  >
    <img
      v-if="fakeImageSrc"
      :class="isEnd ? 'rounded w-100' : 'w-100'"
      :src="fakeImageSrc"
    >
  </div>
</template>

<script>
export default {
  props: {
    isEnd: {
      type: Boolean,
      default: false
    },
    imageSrc: {
      type: String
    }
  },
  computed: {
    fakeImageSrc() {
      if (this.imageSrc && this.imageSrc.includes('url(', 0)) {
        const num = this.imageSrc.length - 2;
        return this.imageSrc.substring(5, num);
      }
      return this.imageSrc;
    }
  }
};
</script>
